<template>
  <v-layout fill-height>
    <v-sheet width="100%" height="100%" elevation="0">
      <v-row align="center" justify="center" fill-height>
        <v-col cols="6" v-if="!$vuetify.breakpoint.xs">
          <v-img height="100vh" :src="loginImg"></v-img>
        </v-col>
        <v-col class="d-flex flex-column justify-center align-center">
          <v-card
            v-if="!message.requestPasswordReset.success"
            max-width="360"
            elevation="0"
            class="d-flex flex-column justify-center align-center pa-5"
          >
            <v-img
              :src="logo"
              max-width="200"
              contain
              position="center center"
            />
            <label
              style="
                color: #19d3da !important;
                font-size: 10px;
                font-weight: bold;
              "
              >DEMAND MEETS SUPPLY</label
            >
            <v-card-title>
              <label>Passwort vergessen?</label>
            </v-card-title>
            <span class="pb-4">
              <v-label> Kein Problem! </v-label>
            </span>
            <v-label>
              Gib hier Deine E-Mail-Adresse an und wir senden Dir ein Link zum
              Zurücksetzen Deines Passworts.
            </v-label>
            <v-form ref="form" @submit.prevent="submitResetRequest">
              <v-row>
                <v-col class="d-flex flex-column">
                  <v-label class="align-self-start">E-Mail</v-label>
                  <v-text-field
                    background-color="#FCFDFE"
                    dense
                    outlined
                    full-width
                    v-model="email"
                    required
                    :rules="[
                      fieldRules.empty,
                      fieldRules.email,
                      fieldRules.length50,
                    ]"
                  />
                  <v-btn
                    type="submit"
                    color="secondary"
                    class="mt-2 rounded-pill align-self-center"
                    width="110"
                    elevation="0"
                  >
                    Absenden
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
            <fly-in-message ref="errorMessage" type="error" />
          </v-card>
          <v-card
            v-if="message.requestPasswordReset.success"
            elevation="0"
            class="d-flex flex-column justify-center align-center pa-5"
          >
            <v-img
              :src="logo"
              max-width="200"
              contain
              position="center center"
            />
            <label
              style="
                color: #19d3da !important;
                font-size: 10px;
                font-weight: bold;
              "
              >DEMAND MEETS SUPPLY</label
            >
            <v-card-title>
              <label>Passwort Reset E-Mail versendet</label>
            </v-card-title>
            <div class="py-4 align-sef-center" style="text-align:center;max-width:335px">
              <v-label max-width="335">
                Wir haben Dir an die angegebenen E-Mail Adresse einen Link zum
                Zurücksetzten Deines Passworts gesendet.
              </v-label>
            </div>
            <v-btn
              @click="$router.push('/login')"
              color="secondary"
              class="mt-2 rounded-pill align-self-center"
              width="110"
              elevation="0"
            >
              Zum Login
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>
  </v-layout>
</template>

<script>
import fieldRules from '../utils/FieldRules'
import { mapActions, mapState } from 'vuex'
import _ from 'lodash'
import logo from '../../../assets/manushare.png'
import loginImg from '../../../assets/login.jpg'
import FlyInMessage from '../FlyInMessage.vue'

export default {
	components: { FlyInMessage },
	name: 'RequestPasswordReset',
	data () {
		return {
			logo: logo,
			loginImg: loginImg,
			fieldRules: fieldRules,
			email: '',
			message: {
				requestPasswordReset: {
					error: '',
					success: ''
				}
			}
		}
	},
	methods: {
		...mapActions('auth', ['requestPasswordReset']),
		submitResetRequest () {
			this.resetMessages()
			if (!this.$refs.form.validate()) {
				return
			}
			this.requestPasswordReset({
				email: this.email
			})
				.then(() => {
					this.message.requestPasswordReset.success =
            'Sofern eine Konto zu dieser E-Mail hinterlegt ist' +
            ' wurde soeben eine E-Mail versendet. ' +
            'Schauen sie in Ihr E-Mail-Postfach und folgen Sie den Anweisungen.'
				})
				.catch(() => {
					this.message.requestPasswordReset.error = 'Fehler bei der Anfrage.'
					this.$refs.errorMessage.show()
				})
		},
		resetMessages () {
			_.set(this.messages, 'requestPasswordReset.error', '')
			_.set(this.messages, 'requestPasswordReset.success', '')
		}
	}
}
</script>

<style scoped>
.v-btn {
  font-family: "Karla";
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  text-align: center;
  border-radius: 19px;
  text-transform: none !important;
}

.v-text-field--outlined >>> fieldset {
  border: 1px solid #f0f1f7;
}

.v-text-field {
  border-radius: 8px;
  font-family: "Karla";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #303941;
}

.v-label {
  font-family: "Karla";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: #667085;
}

.v-form .v-label {
  text-align: left;
  color: #303941;
}

.v-form {
  margin-top: 10%;
  width: 100%;
}
</style>
